import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Tag } from '@app/core/models/Track';
import { AppState } from '@app/core/states/app.state';
import { LibraryModalService } from '@app/library/services/library-modal.service';
import { StartEditTag } from '@app/library/states/radio-tags.actions';
import { RadioTagsState } from '@app/library/states/radio-tags.state';
import { exportSecMin, TimeSplited } from '@app/shared/utils';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import {
  OpenSpecificPanel,
  PANELS_KEYS,
  TryActionUnlessPanelIsBlocking,
} from '@radioking/shared/pannel-manager';
import { SearchBarComponent } from '@radioking/ui/input';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'rk-tag-tracks-header',
  templateUrl: './tag-tracks-header.component.html',
  styleUrls: ['./tag-tracks-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagTracksHeaderComponent {
  @Input()
  tag: Tag;

  @Input()
  displayedTracks: number;

  @Input()
  totalTracks: number;

  @Output()
  readonly changeSearch = new EventEmitter();

  @Select(AppState.history)
  historyStack$: Observable<string[]>;

  @ViewChild('searchBar', { static: true })
  searchBar: SearchBarComponent;

  currentSearchValue: string;

  @Select(RadioTagsState.tagTracksTime)
  tracksTime$: Observable<number>;

  constructor(
    private readonly router: Router,
    private readonly modalService: LibraryModalService,
  ) {}

  goBackToLast() {
    this.historyStack$
      .pipe(
        take(1),
        map(arr => {
          const newArr = arr.filter(str => !str.includes('tag'));
          if (newArr.length === 0) {
            return '/';
          }

          return newArr[newArr.length - 1];
        }),
      )
      .subscribe(route => {
        this.router.navigateByUrl(route);
      });
  }

  @Dispatch()
  startEditTag() {
    return new TryActionUnlessPanelIsBlocking(
      new OpenSpecificPanel(PANELS_KEYS.EDIT_TAG, new StartEditTag(this.tag)),
    );
  }

  placeMatMenu() {
    const matMenu: HTMLElement = document.querySelector('.mat-mdc-menu-panel');
    matMenu.style['position'] = 'absolute';
    matMenu.style.left = '42px';
    matMenu.style.top = '-35px';
  }

  getMinutesAndHours(value: number): TimeSplited {
    return exportSecMin(value);
  }

  onSearchInput(e: string) {
    if (typeof e === 'string') {
      this.currentSearchValue = e;
      this.changeSearch.emit(e);
    }
  }

  clearSearchBar() {
    this.searchBar.value = '';
    this.currentSearchValue = '';
  }

  deleteTag() {
    this.modalService.deleteTag(this.tag, this.totalTracks);
  }
}
